export default "__VITE_ASSET__f9fdea76__"